import React, { createContext, useContext, useState, useEffect } from 'react';

interface ModuleOptionIdsContextProps {
  moduleOptionIds: number[]; // Array of numbers to hold the IDs
  setModuleOptionIds: (newIds: number[]) => void; // Function to update the state
}

const ModuleOptionIdsContext = createContext<ModuleOptionIdsContextProps | undefined>(undefined);

export const useModuleOptionIdsContext = () => {
  const context = useContext(ModuleOptionIdsContext);
  if (!context) {
    throw new Error('useModuleOptionIdsContext must be used within a ModuleOptionIdsProvider');
  }
  return context;
};

interface ModuleOptionIdsProviderProps {
  children: React.ReactNode;
}

const ModuleOptionIdsProvider: React.FC<ModuleOptionIdsProviderProps> = ({ children }) => {
  const [moduleOptionIds, setModuleOptionIds] = useState<number[]>(() => {
    const savedIds = localStorage?.getItem('moduleOptionIds');
    return savedIds !== null ? JSON.parse(savedIds) : [];
  });

  useEffect(() => {
    localStorage?.setItem('moduleOptionIds', JSON.stringify(moduleOptionIds));
  }, [moduleOptionIds]);

  const value: ModuleOptionIdsContextProps = {
    moduleOptionIds,
    setModuleOptionIds,
  };

  return (
    <ModuleOptionIdsContext.Provider value={value}>
      {children}
    </ModuleOptionIdsContext.Provider>
  );
};

export default ModuleOptionIdsProvider;
